<template>
	<div v-if="companies.length > 0">
		<div class="black-text font-weight-black mt-1">Work Experience</div>

		<div v-for="company in companies" :key="company" class="pr-1">
			<v-icon left color="primary" :size="18">mdi-medical-bag</v-icon>
			<small>{{ company }}</small>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LocumWorkExperience',
	props: {
		companies: Array,
	},
};
</script>
